import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import type { CategoryData } from '../../../hooks/useReports';

interface Props {
  data: CategoryData[];
  type: 'despesa' | 'receita';
}

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload as CategoryData;
  return (
    <div className="bg-white border border-gray-100 rounded-xl p-3 text-sm">
      <p className="font-600 text-gray-700">{d.category}</p>
      <p className="text-gray-500 text-xs mt-1">
        {d.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} · {d.percent}%
      </p>
    </div>
  );
};

export const CategoryBreakdown = ({ data, type }: Props) => {
  if (!data.length) {
    return (
      <div className="h-full flex flex-col items-center justify-center gap-2 text-center py-8">
        <i className="ri-pie-chart-line text-3xl text-gray-200" />
        <p className="text-sm text-gray-400">Sem {type === 'despesa' ? 'despesas' : 'receitas'} no período</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-5 items-center">
      <div className="shrink-0 w-[140px] h-[140px] sm:w-[160px] sm:h-[160px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={data} cx="50%" cy="50%" innerRadius={38} outerRadius={60} dataKey="total" paddingAngle={2}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="flex-1 space-y-2 min-w-0 w-full">
        {data.slice(0, 7).map((item) => (
          <div key={item.category} className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: item.color }} />
            <span className="text-[12px] text-gray-600 flex-1 truncate">{item.category}</span>
            <span className="text-[12px] font-600 text-gray-800 shrink-0">
              {item.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
            <span className="text-[11px] text-gray-400 w-[30px] text-right shrink-0">{item.percent}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};
